export class UserPlayerGroupsBridge {
    UserId: number;
    PlayerGroupId: number;

    constructor(userId, playerGroupId) {
		this.UserId = userId;
		this.PlayerGroupId = playerGroupId;
	}
}